export const MessagesRetrievedFromBackend = {
  resetPassword:
    'Falls uns diese Mailadresse bekannt ist, wurde ein Link an sie geschickt. Bitte auch den SPAM-Ordner prüfen.',
};
